import styled from 'styled-components'

export const CanvasStatusWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-self: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  z-index: 1;
`
